<div>
  <div
    [style]="{ 'background-image': styleImage }"
    [ngClass]="[
      'full-avatar',
      frameStyle === PvsAvatarFrameStyle.RECTANGLE ? 'full-avatar--rectangle' : 'full-avatar--round',
      allowAvatarClick ? 'full-avatar__hover' : 'full-avatar__not-hover'
    ]"
    [ngStyle]="{
      width: imgWidth.toString() + 'rem',
      height: imgHeight.toString() + 'rem'
    }"
    (click)="onAvatarClicked($event)"
  >
    <div *ngIf="!!editable">
      <label
        ><nb-icon icon="edit-outline" size="large" (click)="$event.stopPropagation(); onFileClicked($event)"></nb-icon
      ></label>
    </div>
  </div>
  <app-choose-avatar
    [ratio]="ratio"
    [resizeToWidth]="resizeToWidth"
    hidden
    (fileChanged)="fileChanged($event)"
  ></app-choose-avatar>
</div>
<ng-template #dialog let-data let-ref="dialogRef">
  <div id="img-dialog" class="d-flex" (click)="ref.close()">
    <div class="inner">
      <img id="img-full-screen" (click)="ref.close()" src="{{ styleImageHd }}" alt="" />
    </div>
  </div>
</ng-template>
